import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface UseRestockManagementProps {
  selectedItem: any;
  refetch: () => void;
  onClose: () => void;
}

export const useRestockManagement = ({ 
  selectedItem,
  refetch,
  onClose
}: UseRestockManagementProps) => {
  const [restockQuantity, setRestockQuantity] = useState("");
  const isQuantityValid = restockQuantity && parseInt(restockQuantity) > 0;

  const handleRestock = async () => {
    if (!selectedItem?.id || !isQuantityValid) {
      toast.error("Veuillez entrer une quantité valide");
      return;
    }

    const quantity = parseInt(restockQuantity);

    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      const { error: updateError } = await supabase
        .from('stock_items')
        .update({ 
          quantity: selectedItem.quantity + quantity,
          updated_at: new Date().toISOString()
        })
        .eq('id', selectedItem.id);

      if (updateError) throw updateError;

      toast.success("Stock mis à jour avec succès");
      setRestockQuantity("");
      onClose();
      refetch();
      
      return true;
    } catch (error: any) {
      console.error("Erreur lors du réapprovisionnement:", error);
      toast.error(error.message || "Erreur lors du réapprovisionnement");
      return false;
    }
  };

  return {
    restockQuantity,
    setRestockQuantity,
    isQuantityValid,
    handleRestock,
  };
};